import { GrassrootlyTheme } from "./GrassrootlyTheme";

export const ProjectThemes = [GrassrootlyTheme];
export const defaultTheme = GrassrootlyTheme.key;
